/** The NOOS Lifecycle stage column on both tabs; named in `columnUtils.ts`. */
export enum Demand2LifecycleStageColumn {
  LifecycleStage = "demand2-lifecycle-stage",
}
